"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnFieldsQueryGrid = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const shared_urls_1 = require("@tableau/shared-urls");
const react_1 = tslib_1.__importDefault(require("react"));
const LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.columns && resultData.columns[0] && resultData.columns[0].referencedByFieldsConnection;
}
function mapResultNode(_a) {
    var _b, _c, _d, _e, _f;
    var { id, name } = _a, node = tslib_1.__rest(_a, ["id", "name"]);
    const workbookVizportalUrlId = ((_b = node.datasource) === null || _b === void 0 ? void 0 : _b.__typename) === 'EmbeddedDatasource' && node.datasource.workbook
        ? node.datasource.workbook.vizportalUrlId
        : '';
    const embeddedDatasourceNodeId = ((_c = node.datasource) === null || _c === void 0 ? void 0 : _c.__typename) === 'EmbeddedDatasource' ? node.datasource.id : '';
    const publishedDatasourceVizportalUrlId = ((_d = node.datasource) === null || _d === void 0 ? void 0 : _d.__typename) === 'PublishedDatasource'
        ? node.datasource.vizportalUrlId
        : '';
    return {
        id,
        name,
        workbookVizportalUrlId,
        embeddedDatasourceNodeId,
        publishedDatasourceVizportalUrlId,
        datasourceName: (_f = (_e = node.datasource) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : '',
    };
}
function urlForLink(urls, rowData) {
    return rowData.workbookVizportalUrlId
        ? urls.workbookLineageFieldPath(rowData.workbookVizportalUrlId, rowData.id)
            + filterToEmbeddedDatasource(rowData.embeddedDatasourceNodeId)
        : urls.datasourceLineageFieldPath(rowData.publishedDatasourceVizportalUrlId, rowData.id);
}
function filterToEmbeddedDatasource(datasourceId) {
    return `?${shared_urls_1.CatalogUrlParamKeys.embeddedDataSource}=` + datasourceId;
}
function nameForLink(rowData) {
    if (rowData.name === null) {
        return null;
    }
    return catalog_messages_1.Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.datasourceName });
}
function ColumnFieldsQueryGrid(props) {
    const emptyGridMessage = catalog_messages_1.Messages.EmptyColumnUsedByFieldsGridMessage();
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.ColumnFieldsDocument, partialQueryVariables: { columnId: props.columnId }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, ({ rowStore }) => (react_1.default.createElement(LinksDisplayGrid_1.LinksDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, link: urlForLink, name: nameForLink }))));
}
exports.ColumnFieldsQueryGrid = ColumnFieldsQueryGrid;
//# sourceMappingURL=ColumnFieldsQueryGrid.js.map